import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Form from "olive-react-myoneui/lib/Form";
import Card from "olive-react-myoneui/lib/Card";
import Button from "olive-react-myoneui/lib/Button";
import { caretIcon } from '../../../constants/icons';
import { useDispatch, useSelector } from 'react-redux';
import { saveProfileAbout, updateProfileFields } from "../../../../api/afterLogin/learners";
import Dropdown from "olive-react-myoneui/lib/Dropdown";
import {
    getCountryCodes,
    getOrganizations,
    getTimezone,
    updateLearner,
  } from "../../../../api/afterLogin/learners";
import { setConfigData } from '../../../../reducers/configSlice';
import { Toast, ToastInfo } from "olive-react-myoneui";
import { setSidebarData } from "../../../../reducers/sidebarSlice";
import MobileUpdateModal from '../MobileUpdateModal';

const CompleteLearnerProfile = ({setShowComplete, profileFieldBlocks, hasMissingDataForMandatoryFields, className}) => {
    const configData = useSelector((state) => state.config);
    const [selectedPhoneCountryCode, setSelectedPhoneCountryCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const [selectedPhoneCountryCallingCode, setSelectedPhoneCountryCallingCode] = useState("");
    const [allCountryCodes, setAllCountryCodes] = useState([]);
    const [allTimezones, setAllTimeZones] = useState({});
    const [selectedTimeZone, setSelectedTimeZone] = useState("");
    const [searchCountry, setSearchCountry] = useState("");
    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const [timezoneSearch, setTimezoneSearch] = useState("");
    const [showTimezoneDropdown, setShowTimezoneDropdown] = useState(false);
    const [timezoneError, setTimezoneError] = useState(false);
    const [showErrorProfileUpdate, setShowErrorProfileUpdate] = useState(false);
    const [errorProfileMessage, setErrorProfileMessage] = useState({});
    const [profileFieldValue, setProfileFieldValue] = useState({});
    const [initiallyFilledFields, setInitiallyFilledFields] = useState({});
    const [inValid, setInValid] = useState({
        us_house_name: false,
        us_pincode: false,
        us_phone: false,
    });
    const oldPhone = configData?.session?.us_phone;
    const [showMobileUpdateModal, setShowMobileUpdateModal]     = useState(false);
    const [showMobileUpdateMessage, setShowMobileUpdateMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const dispatch = useDispatch();
    const learnerDetails = configData.session;
    const address_mandatory = configData?.address_mandatory === "1";
    const phno_mandatory = configData?.phno_mandatory === "1";
    const userPhone = configData?.session?.us_phone;
    const userCountryCode = configData?.session?.us_country_code;
    const isPhoneAvailable = userPhone && userPhone.trim() !== "" && userCountryCode && userCountryCode.trim() !== "";
    const learnerProfileFields = configData.session.us_profile_fields;
    const profileFields = learnerProfileFields && learnerProfileFields !== null ? learnerProfileFields.split("{#}") : false;
    const userProfileFieldData = {};
    if (profileFields) {
        profileFields.forEach((field) => {
          field = field.substring(2, field.length - 2);
          if (field != "{=>}") {
            const tempField = field.split("{=>}");
            const key = tempField[0] || 0;
            const value = tempField[1] || "";
            userProfileFieldData[key] = value;
          }
        });
    }
    const navigate      = useNavigate();
  const [formData, setFormData] = useState({
    user_name: "",
    forsid: "",
    studentGrade: "",
  });

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    setIsPhoneValid(value.trim() !== "");
    setFormData({ ...formData, phone_number: value });
  };
  const hasMandatoryFields = Object.values(profileFieldBlocks || {}).some(
    block => block.profile_fields?.some(field => field.pf_mandatory === "1")
  );
  
  const handlePhoneCountryChange = (option) => {
    setFormData({
      ...formData,
      phone_country_code: option.country_code,
      us_country: option.country_name,
      phone_calling_code: "+"+option.calling_code
    });
    setSelectedPhoneCountryCode(option.country_code);
    setSelectedPhoneCountryCallingCode("+"+option.calling_code);
  };

  const handleTimeZoneChange = (key) => {
    setFormData({ ...formData, timezone: key });
    setSelectedTimeZone(allTimezones[key]);
    setTimezoneError(false);
  };

  const loadInitialLearnerDetails = async () => {
    const timezones = await getTimezone(configData.access_token);
    const organizations = await getOrganizations(configData.access_token);
    const countryCodes = await getCountryCodes(configData.access_token);
    const selectedOrganization = organizations.find(
      (org) => org.id === learnerDetails.us_organization_id
    );
    const addressObject =
      learnerDetails.us_address != null
        ? JSON.parse(learnerDetails.us_address)
        : {};

        let countryDetails = null;
        let countryCode = addressObject?.us_country || learnerDetails?.us_country || '';

        if (countryCode) {
            countryDetails = countryCodes.find(
                (country) =>
                country.country_code === countryCode || country.country_name === countryCode
            );
        } else if (learnerDetails?.us_country_code) {
            const normalizedCallingCode = String(learnerDetails.us_country_code).trim().replace(/^\+/, "");
            countryDetails = countryCodes.find((country) =>
                String(country.calling_code).trim().replace(/^\+/, "") === normalizedCallingCode
            );
        }    
        if (countryDetails) {
            countryCode = countryDetails.country_code;
        }    
        const countryName = countryDetails ? countryDetails.country_name : countryCode;
      
    setFormData({
      user_name: learnerDetails?.us_name,
      email: learnerDetails?.us_email,
      us_house_name: addressObject?.us_house_name ?? "",
      us_location: addressObject?.us_location ?? "",
      us_district: addressObject?.us_district ?? "",
      us_state: addressObject?.us_state ?? "",
      us_pincode: addressObject?.us_pincode ?? "",
      us_country: countryName,
      phone_country_code: countryCode,
      phone_calling_code: learnerDetails?.us_country_code ?? "",
      timezone: learnerDetails?.us_timezone ?? "",
      phone_number: learnerDetails?.us_phone ?? "",
      organization: selectedOrganization?.id ?? 0,
    });

    setInitiallyFilledFields({
      user_name: learnerDetails?.us_name,
      email: learnerDetails?.us_email,
      us_house_name: addressObject?.us_house_name ?? "",
      us_location: addressObject?.us_location ?? "",
      us_district: addressObject?.us_district ?? "",
      us_state: addressObject?.us_state ?? "",
      us_pincode: addressObject?.us_pincode ?? "",
      us_country: countryName,
      phone_country_code: countryName,
      phone_calling_code: learnerDetails?.us_country_code ?? "",
      timezone: learnerDetails?.us_timezone ?? "",
      phone_number: learnerDetails?.us_phone ?? "",
    });

    setAllTimeZones(timezones);
    setAllCountryCodes(countryCodes);
    setSelectedPhoneCountryCode(countryCode);
    setSelectedPhoneCountryCallingCode(learnerDetails?.us_country_code ?? "");
    setPhoneNumber(learnerDetails?.us_phone ?? "");
    setSelectedTimeZone(
      learnerDetails?.us_timezone ? timezones[learnerDetails.us_timezone] : ""
    );
  };

  useEffect(() => {
    loadInitialLearnerDetails();
  }, []);


    const [validated, setValidated] = useState(false);
    let canShowSkipButton = true;
    if (hasMissingDataForMandatoryFields) {
        canShowSkipButton = false;
    } 
    if (address_mandatory) {
    const addressObject =
        learnerDetails.us_address != null
            ? JSON.parse(learnerDetails.us_address)
            : {};
            
    const hasHouseName = (addressObject?.us_house_name ?? "").trim() !== "";
    const hasPincode = (addressObject?.us_pincode ?? "").trim() !== "";
        
        if (!hasHouseName || !hasPincode) {
            canShowSkipButton = false;
        }
    }
    if (phno_mandatory && !isPhoneAvailable) {
        canShowSkipButton = false;
    }
   
    const handleSkip = () => {
        localStorage.setItem("profileSkipped", "true");
        setShowComplete(1);
        navigate('/student-dashboard');
    };

    const handleSubmit =  async(event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsSubmitting(true);
        const newInvalid = {
            us_house_name: address_mandatory ? formData.us_house_name.trim() === "" : false,
            us_pincode: address_mandatory ? formData.us_pincode.trim() === "" : false,
            us_phone: phno_mandatory ? phoneNumber.trim() === "" : false,
        };

        setInValid(newInvalid);
        setIsPhoneValid(!newInvalid.us_phone);

        if (Object.values(newInvalid).some(val => val)) {
            setIsSubmitting(false);
            return;
        }
        
        const form = event.currentTarget;

        setValidated(true);

        if (form.checkValidity() === false) {
            return;
        }
        let isProfileAboutSaved = false;
        let updatedUserData = {};
        try {
            const postParams = {
                user_name: formData?.user_name ?? '',
                email_id: formData?.email ?? '',
                phone_country_code: formData?.phone_calling_code ?? '',
                user_country: formData?.us_country ?? '',
                us_country: formData?.phone_country_code ?? '',
                us_house_name: formData?.us_house_name ?? '',
                us_location: formData?.us_location ?? '',
                us_district: formData?.us_district ?? '',
                us_state: formData?.us_state ?? '',
                us_pincode: formData?.us_pincode ?? '',
                phone_number: formData?.phone_number ?? '',
                us_timezone: formData?.timezone ?? '',
            };
            
            const response = await saveProfileAbout(configData.access_token, postParams);
      
            if(response.status === 1) {
                isProfileAboutSaved = true;
                const us_address = JSON.stringify({
                    us_country: formData.us_country,
                    us_pincode: formData.us_pincode,
                    us_state: formData.us_state,
                    us_district: formData.us_district,
                    us_location: formData.us_location,
                    us_house_name: formData.us_house_name,
                });
                updatedUserData = {
                    ...learnerDetails,
                    us_address: us_address,
                    us_name: formData.user_name,
                    us_email: formData.email,
                    us_phone: formData.phone_number,
                    us_country_code: formData.phone_calling_code,
                    us_timezone: formData.timezone,
                    us_profile_completed: 1
                };
                dispatch(setConfigData({ session: updatedUserData }));
            }
            if(response.status === 2) {
                setShowErrorProfileUpdate(true);
                setErrorProfileMessage({message:response.message});
            }
            let blockDefaultFieldValue = {};
            if (Object.keys(profileFieldValue).length === 0 && Object.keys(profileFieldBlocks).length > 0) {
                Object.values(profileFieldBlocks).forEach((block) => {
                    block.profile_fields.forEach((block_pf) => {
                        blockDefaultFieldValue[block.id] = {
                            ...blockDefaultFieldValue[block.id],
                            [block_pf.pf_name]: userProfileFieldData[block_pf.id] ?? "",
                        };
                    });
                });
            }
            
            let combinedBlockValue = {};
            const allBlockIds = Object.keys(profileFieldBlocks);
            allBlockIds.forEach((id) => {
                const currentValue =
                  Object.keys(profileFieldValue).length === 0 &&
                  Object.keys(blockDefaultFieldValue).length > 0
                    ? blockDefaultFieldValue[id]
                    : profileFieldValue[id];
              
                if (currentValue) {
                    combinedBlockValue = {
                        ...combinedBlockValue,
                        ...currentValue,
                    };                
                }
            });
            if (combinedBlockValue) {
                try {
                    const profileFieldsResponse = await updateProfileFields(configData.access_token, combinedBlockValue);

                    if (profileFieldsResponse.status === 200) {
                        const updatedUserDataFinal = {
                            ...learnerDetails,
                            ...updatedUserData,
                        us_profile_fields: profileFieldsResponse?.data,
                        };
                        if (oldPhone !== formData.phone_number) {
                            setShowMobileUpdateMessage(`Contact number updated to ${formData.phone_number}, so user need to re-login`);
                            setShowMobileUpdateModal(true);
                            localStorage.setItem("email_contact_updated", Date.now() + 2 * 60 * 1000);
                            return;
                        }
                        if (isProfileAboutSaved) { 
                            dispatch(setConfigData({ session: updatedUserDataFinal }));
                            dispatch(setSidebarData({ isSidebarDisable: false }));
                            setShowComplete(1);
                            navigate('/student-dashboard');
                        }
                    }
                } catch(err) {
                    console.log(err);
                }
            } else {
                if (isProfileAboutSaved) {
                    if (oldPhone !== formData.phone_number) {
                        setShowMobileUpdateMessage(`Contact number updated to ${formData.phone_number}, so user need to re-login`);
                        setShowMobileUpdateModal(true);
                        localStorage.setItem("email_contact_updated", Date.now() + 2 * 60 * 1000);
                        return;
                    }
                    dispatch(setConfigData({ session: updatedUserData }));
                    dispatch(setSidebarData({ isSidebarDisable: false }));
                    setShowComplete(1);
                    navigate('/student-dashboard');
                }
            }
        } catch(err) {
            console.log(err);
        }
    };
    return (
        <div className={`${className || ""} myk__stu-complete_prof-wrapper`}>
            <Card className="myk__stu-complete_profile border-0">
                <Card.Body className="p-0">
                <Form className="col-xl-12" noValidate validated={validated} onSubmit={handleSubmit}>
                    <div className="myk__stu-heading-block">
                        <h2><strong>Complete Your Profile</strong></h2>
                        <p className="help-text">Once the profile is completed, you'll be able to access full feature of Learner's Dashboard.</p>
                    </div>
                    <div style={{ display: showErrorProfileUpdate ? "block" : "none" }}>
                        <Toast variant="error" className="mb-2 mt-2">
                        <Toast.Body>
                            <div className="flex flex-column">
                            {Object.values(errorProfileMessage).map((message) => (
                                <ToastInfo toastDescription={message} />
                            ))}
                            </div>
                            <div className="action-wrapper">
                            <Button
                                variant="error"
                                type="button"
                                size="sm"
                                className="btn-round bg-orange-fade text-white"
                                aria-label="Close"
                                onClick={() => setShowErrorProfileUpdate(false)}
                            >
                                Close
                            </Button>
                            </div>
                        </Toast.Body>
                        </Toast>
                    </div>
                    {!initiallyFilledFields.user_name && (
                    <Form.Group className="mb-4" controlId="user_name" label="Full Name" >
                        <Form.Label>Full name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Full Name."
                            name="user_name"
                            value={formData.user_name}
                            onChange={(e) => setFormData({ ...formData, user_name: e.target.value })}
                            size="sm"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide your Full Name.
                        </Form.Control.Feedback>
                    </Form.Group>
                    )}
                    {!(initiallyFilledFields.phone_country_code && initiallyFilledFields.phone_calling_code && initiallyFilledFields.phone_number) && (
                    <Form.Group className={`mb-4 ${!isPhoneValid ? "is-invalid" : ""}`} controlId="phone_number">
                        <Form.Label>
                            Phone Number 
                            {phno_mandatory && <span className="text-danger"> *</span>}
                        </Form.Label>
                        <div
                            className={`myk__stu-number-group form-control ${
                            !isPhoneValid ? "is-invalid" : ""
                            }`}
                        >
                            <Dropdown
                                className="dropdown-select text-start myk__stu-ph-country"
                                align="start"
                                show={showCountryDropdown}
                                onToggle={(isOpen) => {
                                    setShowCountryDropdown(isOpen);
                                    if (!isOpen) setSearchCountry("");
                                }}
                            >
                                <Dropdown.Toggle
                                    as="div"
                                    role="button"
                                    tabIndex={0}
                                    className="border-0"
                                >
                                    <Form.Control
                                        type="text"
                                        placeholder="Country"
                                        value={selectedPhoneCountryCode}
                                        name="us_country"
                                        id="phcountry"
                                        readOnly
                                        required={phno_mandatory == 1}
                                        onClick={() => setShowCountryDropdown(true)}
                                    />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu p-2">
                                    <div className="search-box">
                                        <Form.Control
                                            type="text"
                                            placeholder="Search country..."
                                            value={searchCountry}
                                            onChange={(e) => {
                                                setSearchCountry(e.target.value);
                                                setShowCountryDropdown(true);
                                            }}
                                            autoFocus
                                            className="myk__stu-ddmenu-search w-100 mb-2"
                                        />
                                    </div>
                                    {allCountryCodes
                                        .filter(option => 
                                            option.country_name.toLowerCase().includes(searchCountry.toLowerCase()) ||
                                            option.country_code.toLowerCase().includes(searchCountry.toLowerCase())
                                        )
                                        .map((option) => (
                                            <Dropdown.Item
                                                key={option.country_code}
                                                onClick={() => {
                                                    handlePhoneCountryChange(option);
                                                    setShowCountryDropdown(false);
                                                }}
                                                className="select-item"
                                            >
                                                ({option.country_code}) {option.country_name}
                                            </Dropdown.Item>
                                        ))}
                                </Dropdown.Menu>
                            </Dropdown>
                            <Form.Control
                            type="text"
                            name="phcode"
                            id="phcode"
                            placeholder="Code"
                            value={selectedPhoneCountryCallingCode}
                            className="myk__stu-ph-code"
                            readOnly
                            />
                            <Form.Control
                            type="number"
                            name="phone"
                            placeholder="Number"
                            value={phoneNumber}
                            onChange={handlePhoneChange}
                            className={`myk__stu-ph-number ${
                                !isPhoneValid ? "is-invalid" : ""
                            }`}
                            aria-invalid={!isPhoneValid}
                            required={phno_mandatory == 1}
                            />
                        </div>
                        {!isPhoneValid && (
                            <Form.Control.Feedback type="invalid" className="d-block">
                            Please provide your Phone Number.
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    )}
                    {!initiallyFilledFields.us_house_name && (
                    <Form.Group className="mb-4" controlId="us_house_name" label="Address 1" >
                        <Form.Label>
                            Address 1
                            {address_mandatory && <span className="text-danger"> *</span>}
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Address 1"
                            name="us_house_name"
                            value={formData.us_house_name}
                            onChange={(e) => {setFormData({ ...formData, us_house_name: e.target.value }); setInValid({ ...inValid, us_house_name: e.target.value.trim() === "" });}}
                            size="sm"
                            required={address_mandatory == 1}
                            isInvalid={inValid.us_house_name}
                        />
                        {inValid.us_house_name && (
                        <Form.Control.Feedback type="invalid">
                            Please provide Address 1
                        </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    )}
                    {!initiallyFilledFields.us_location && (
                    <Form.Group className="mb-4" controlId="us_location" label="Address 2" >
                        <Form.Label>Address 2</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Address 2"
                            name="us_location"
                            value={formData.us_location}
                            onChange={(e) => setFormData({ ...formData, us_location: e.target.value })}
                            size="sm"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide Address 2
                        </Form.Control.Feedback>
                    </Form.Group>
                    )}
                    {!initiallyFilledFields.us_district && (
                    <Form.Group className="mb-4" controlId="us_district" label="City/Town" >
                        <Form.Label>City/Town</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="City/Town"
                            name="us_district"
                            value={formData.us_district}
                            onChange={(e) => setFormData({ ...formData, us_district: e.target.value })}
                            size="sm"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide City/Town
                        </Form.Control.Feedback>
                    </Form.Group>
                    )}
                    {!initiallyFilledFields.us_state && (
                    <Form.Group className="mb-4" controlId="us_state" label="Province/ Country/ State" >
                        <Form.Label>Province/ Country/ State</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Province/ Country/ State"
                            name="us_state"
                            value={formData.us_state}
                            onChange={(e) => setFormData({ ...formData, us_state: e.target.value })}
                            size="sm"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide Province/ Country/ State
                        </Form.Control.Feedback>
                    </Form.Group>
                    )}
                    {!initiallyFilledFields.us_pincode && (
                    <Form.Group className="mb-4" controlId="us_pincode" label="Postcode/ Zipcode" >
                        <Form.Label>
                            Postcode/ Zipcode
                            {address_mandatory && <span className='text-danger'> *</span>}
                        </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Postcode/ Zipcode"
                            name="us_pincode"
                            value={formData.us_pincode}
                            onChange={(e) => {setFormData({ ...formData, us_pincode: e.target.value }); setInValid({ ...inValid, us_pincode: e.target.value.trim() === "" });}}
                            required={address_mandatory == 1}
                            isInvalid={inValid.us_pincode}
                            size="sm"
                        />
                        {inValid.us_pincode && (
                        <Form.Control.Feedback type="invalid">
                            Please provide Zipcode
                        </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    )}
                    {!initiallyFilledFields.us_country && (
                    <Form.Group className="mb-4" controlId="us_country" label="Country">
                        <Form.Label>Country</Form.Label>

                        <Form.Control
                            type="text"
                            placeholder="Country"
                            name="us_country"
                            value={formData.us_country}
                            size="sm"
                            disabled
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide country.
                        </Form.Control.Feedback>
                    </Form.Group>
                    )}
                    {!initiallyFilledFields.timezone && (
                    <Form.Group className="mb-4" controlId="timezone" label="Timezone">
                        <div className="myk_stu-dropdown-group">
                            <Form.Label>Timezone</Form.Label>
                            <Dropdown 
                                className="dropdown-select text-start" 
                                align="start"
                                show={showTimezoneDropdown}
                                onToggle={(isOpen) => {
                                    setShowTimezoneDropdown(isOpen);
                                    if (!isOpen) setTimezoneSearch('');
                                }}
                            >
                                <Dropdown.Toggle as="div" role="button" tabIndex={0} className="border-0">
                                    <Form.Control
                                        type="text"
                                        placeholder="Time Zone"
                                        name="timezone"
                                        value={showTimezoneDropdown ? selectedTimeZone : (selectedTimeZone || '')}
                                        readOnly
                                        isInvalid={timezoneError}
                                        onClick={() => setShowTimezoneDropdown(true)}
                                    />
                                </Dropdown.Toggle>
                                
                                <Dropdown.Menu className="dropdown-menu p-2">
                                    <div className="search-box">
                                        <Form.Control
                                            type="text"
                                            placeholder="Search Time Zone"
                                            name="timezone-search"
                                            value={timezoneSearch}
                                            onChange={(e) => {
                                                setTimezoneSearch(e.target.value);
                                                setShowTimezoneDropdown(true);
                                            }}
                                            autoFocus
                                            className="mb-2 w-100"
                                        />
                                    </div>
                                    {Object.entries(allTimezones)
                                        .filter(([key, value]) => 
                                            value.toLowerCase().includes(timezoneSearch.toLowerCase())
                                        )
                                        .map(([key, value]) => (
                                            <Dropdown.Item
                                                key={key}
                                                onClick={() => {
                                                    handleTimeZoneChange(key);
                                                    setShowTimezoneDropdown(false);
                                                }}
                                                className="select-item"
                                            >
                                                {value}
                                            </Dropdown.Item>
                                        ))}
                                </Dropdown.Menu>
                            </Dropdown>
                            {timezoneError && <div className="invalid-feedback d-block">Please provide your timezone.</div>}
                        </div>
                    </Form.Group>
                    )}
                    {profileFieldBlocks && Object.keys(profileFieldBlocks).length > 0 && Object.values(profileFieldBlocks).map((block) =>
                        block.profile_fields.map((block_pf) => {
                            if (userProfileFieldData[block_pf.id] && userProfileFieldData[block_pf.id].trim() !== "") {
                            return null;
                            }
                        return (
                        <Form.Group 
                            className="mb-4" 
                            controlId={block_pf.pf_name} 
                            key={block_pf.id} 
                            label={block_pf.pf_label}
                        >
                            <Form.Label>
                                {block_pf.pf_label}
                                {block_pf.pf_mandatory === "1" && <span style={{ color: "red" }}> *</span>}
                            </Form.Label>
                            {block_pf.pf_field_input_type == 1 ? (
                              <Form.Control
                                type="text"
                                placeholder={block_pf.pf_placeholder}
                                name="fullname"
                                defaultValue={
                                  userProfileFieldData[block_pf.id] ?? ""
                                }
                                onChange={(e) =>
                                  setProfileFieldValue({
                                    ...profileFieldValue,
                                    [block.id]: {
                                      ...profileFieldValue[block.id],
                                      [block_pf.pf_name]: e.target.value,
                                    },
                                  })
                                }
                                required={block_pf.pf_mandatory == 1}
                                disabled={block_pf.pf_azure_custom_field == 1}
                              />
                            ) : (
                              <div className="myk_stu-dropdown-default">
                              <div className="myk_stu-selectdrop">
                              <Form.Select
                                aria-label="Default select example"
                                disabled={block_pf.pf_azure_custom_field == 1}
                                required={block_pf.pf_mandatory == 1}
                                style={{ color: "#000", padding: "10px 15px" }}
                                onChange={(e) =>
                                  setProfileFieldValue({
                                    ...profileFieldValue,
                                    [block.id]: {
                                      ...profileFieldValue[block.id],
                                      [block_pf.pf_name]: e.target.value,
                                    },
                                  })
                                }
                              >
                                <option value="">{`Choose ${block_pf.pf_label}`}</option>
                                {block_pf.pf_default_value
                                  .split(",")
                                  .map((defaultValue) => {
                                    const fieldValue =
                                      userProfileFieldData[block_pf.id] ?? "";
                                    const selected =
                                      fieldValue === defaultValue
                                        ? true
                                        : false;
                                    return (
                                      <option
                                        value={defaultValue}
                                        selected={selected}
                                      >
                                        {defaultValue}
                                      </option>
                                    );
                                  })}
                                ;
                              </Form.Select>
                              <div className="caret-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="6.119"
                                  height="11.658"
                                  viewBox="0 0 6.119 11.658"
                                >
                                  <path
                                    id="Path_21616"
                                    data-name="Path 21616"
                                    d="M0,0,4.42,3.71,8.84,0"
                                    transform="translate(1.409 10.249) rotate(-90)"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                  />
                                </svg>
                              </div>
                              </div>
                              </div>
                            )}
                            <p className="help-text">
                              {block_pf.pf_purpose_field}
                            </p>
                            <Form.Control.Feedback type="invalid">
                            Please provide your {block_pf.pf_label}.
                            </Form.Control.Feedback>
                        </Form.Group>
                        );
                        })
                    )}

                    <div className="action-btns text-end mt-4 pt-2">
                        {!isSubmitting && canShowSkipButton && (
                            <Button variant="secondary" className="me-2" onClick={() => handleSkip()}>Skip for now</Button>
                        )}
                        <Button variant="primary" type="submit">Complete Profile & Proceed</Button>
                    </div>
                </Form>
                </Card.Body>
            </Card>
            {showMobileUpdateModal && (
                <MobileUpdateModal title={'Contact Number Updated'} message={showMobileUpdateMessage} />
            )}
        </div>
    )
};

export default CompleteLearnerProfile;
